export const addressFields = `
  title
  street
  streetNumber: street_number
  streetNumberSuffix: street_number_suffix
  zipcode
  city
  country
`;
